import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { addDoc, collection } from "firebase/firestore";
import { useState } from "react";
import { projDataBase } from "../../firebase/firebase";
import BulkUploadData from "./BulkUploadData";
import {
  addProduct,
  checkIfDuplicateExists,
} from "../../firebase/fireStoreServices";

export default function ProductAdminForm() {
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    description: "",
    image: "",
    weight: "",
    price: 0,
    discount: 0,
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const isDuplicate = await checkIfDuplicateExists("products", {
        name: formData.name,
        image: formData.image,
      });

      if (isDuplicate) {
        alert("This product is already present in the database!");
        return;
      } else {
        await addDoc(collection(projDataBase, "products"), {
          ...formData,
          price: Number(formData.price),
          discount: Number(formData.discount),
        });
        alert("Product Added Successfully!");

        setFormData({
          id: "",
          name: "",
          description: "",
          image: "",
          weight: "",
          price: 0,
          discount: 0,
        });
      }
    } catch (error) {
      console.error("Error adding document: ", error);
      alert("Failed to add product");
    }
    console.log("Product Data Submitted: ", formData);
    // Future step: Send this data to Firestore or a local JSON file
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{ mt: 5, p: 4, bgcolor: "#f9f9f9", borderRadius: 3, boxShadow: 3 }}
      >
        <Typography variant="h5" mb={3} fontWeight="bold" textAlign="center">
          Product Admin Form
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Product ID"
                name="id"
                fullWidth
                value={formData.id}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Product Name"
                name="name"
                fullWidth
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Description"
                name="description"
                fullWidth
                multiline
                rows={3}
                value={formData.description}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Image Path or URL"
                name="image"
                fullWidth
                value={formData.image}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Weight"
                name="weight"
                fullWidth
                value={formData.weight}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Price (₹)"
                name="price"
                type="number"
                fullWidth
                value={formData.price}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Discount (%)"
                name="discount"
                type="number"
                fullWidth
                value={formData.discount}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} textAlign="center">
              <Button type="submit" variant="contained" color="secondary">
                Add Product
              </Button>
            </Grid>
          </Grid>
        </form>
        <Divider sx={{ mt: 3 }} />
        <BulkUploadData collectionName="products" uploadService={addProduct} />
      </Box>
    </Container>
  );
}
